import {
  executeAXRuntimeGuard,
} from './AXRuntimeGuardHook';

export interface AXOperationalCertification {
  readonly certified: boolean;
  readonly governor: string;
  readonly status: 'operational' | 'not-operational';
  readonly certifiedAt: string;
}

export function certifyAXGovernor():
AXOperationalCertification {

  const runtime =
    executeAXRuntimeGuard();

  return Object.freeze({
    certified: runtime.allowed,
    governor: runtime.governor,
    status:
      runtime.allowed
        ? 'operational'
        : 'not-operational',
    certifiedAt: runtime.evaluatedAt,
  });
}
